/**
 * Maps frontend account type values to backend API enum values.
 * Backend enum: MERCHANT_ACCOUNT_TYPE in db.constant.ts
 */
const ACCOUNT_TYPE_TO_API = {
  freelancer: 'FREELANCER',
  corporate_non_fi: 'CORPORATE_NON_FINANCIAL_INSTITUTION',
  corporate_fi: 'CORPORATE_FINANCIAL_INSTITUTION'
};

const API_TO_ACCOUNT_TYPE = Object.fromEntries(
  Object.entries(ACCOUNT_TYPE_TO_API).map(([k, v]) => [v, k])
);

export { ACCOUNT_TYPE_TO_API, API_TO_ACCOUNT_TYPE };
